<template></template>

<script>
import axios from "axios";
import draggable from "vuedraggable";
import BeaconSetting from "../../pages/clusters/BeaconSetting";
import DeviceSetting from "../../pages/clusters/DeviceSetting";
const {
  canAssignBeaconsToClusterTag,
  normalizeMountedValue,
  isMobileMounted,
  hasMobileTypeTag,
} = require("../clusterBeaconValidation");

export default {
  MOBILE_BEACON_CLUSTER_TAG_ERROR: "移動型ビーコンをクラスタへ登録する場合、タグ名は”type: mobile”に設定して下さい",
  data() {
    return {
      parants: [],
      beacons: [],
      clusters: [],
      devices: [],
    };
  },
  components: {
    draggable,
    BeaconSetting,
    DeviceSetting
  },
  methods: {
    onFetchParents() {
      axios
        .get("/clusters/allExcept", {
          params: {
            except: this.items.id
          }
        })
        .then(response => {
          if (response.data.code === 200) {
            this.parants = response.data.payload.hits;
            this.parants.unshift({
              id: "",
              name: ""
            });
          } else {
          }
        });
    },
    onFilterBeacons(id) {
      return this.items.beacons.filter(item => item.id !== id);
    },
    onFetchBeaconsAndDevices() {
      return Promise.all([
        axios.get("/clusters/beacons"),
        axios.get("/clusters/devices")
      ]).then(([beaconRes, deviceRes]) => {
        if (beaconRes.data.code === 200) {
          this.beacons = beaconRes.data.payload.hits.filter(
            item => item.enabled
          );
        }

        if (deviceRes.data.code === 200) {
          this.devices = deviceRes.data.payload.hits.filter(
            item => item.status && item.mounted
          );
        }

        this.handleDataBeacons();
      }).catch(err => {
        console.error("Error fetching beacons/devices", err);
      });
    },
    handleDataBeacons() {
      let arrBeacons = this.beacons.map((beacon) => ({...beacon, mounted: normalizeMountedValue(beacon.mounted), type: "beacon", displayed: true}));
      let arrDevices = this.devices.map((device) => ({...device, mounted: normalizeMountedValue(device.mounted), type: "device", displayed: true}));
      this.beacons = [...arrBeacons, ...arrDevices];
    },
    isMobileBeacon(item) {
      return item && item.type === "beacon" && isMobileMounted(item.mounted);
    },
    normalizeMountedValue,
    hasMobileTypeTag(tag) {
      return hasMobileTypeTag(tag);
    },
    hasSelectedMobileBeacons(items = []) {
      return items.some(item => this.isMobileBeacon(item));
    },
    notifyInvalidMobileBeaconTag() {
      this.onNotify({
        type: "error",
        text: this.$options.MOBILE_BEACON_CLUSTER_TAG_ERROR
      });
    },
    getClusterSaveErrorMessage(error) {
      const payload = (((error || {}).response || {}).data || {}).payload || {};
      const errors = payload.errors || {};
      const text = Object.values(errors).flat().join("<br>");

      if (text) return text;
      if (payload.message) return payload.message;
      return "保存に失敗しました";
    },
    validateMobileBeaconClusterTag(items = this.items.beacons, tag = this.items.tag) {
      if (canAssignBeaconsToClusterTag(items, tag)) {
        return true;
      }

      this.notifyInvalidMobileBeaconTag();
      return false;
    },
    onFetchAllParents() {
      // get all the clusters
      // the v-select in ClustersSearchOpeations which uses it will store the cluster id as parent id
      // the search will then look for any cluster which this cluster as parent
      axios.get("/clusters/parents").then(response => {
        if (response.data.code === 200) {
          this.clusters = response.data.payload.hits;
        } else {
        }
      });
    }
  }
};
</script>

<style>
</style>
